import { styled } from '@linaria/react';
import { themeCssVariables } from 'app-ui/theme';

// Keeps the header line of the page card in place while a page downloads,
// so the frame doesn't jump.
const StyledHeaderPlaceholder = styled.div`
  background: ${themeCssVariables.background.secondary};
  border-bottom: 1px solid ${themeCssVariables.border.color.medium};
  box-sizing: border-box;
  flex: none;
  height: ${themeCssVariables.spacing[12]};
`;

export const PageLoadingFallback = () => (
  <StyledHeaderPlaceholder aria-busy="true" />
);
